import React from "react";
import PropTypes from "prop-types";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftButton from "components/SoftButton";
import Icon from "@mui/material/Icon";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import { accentBtnSx } from "../../../colors";

export default function ActionRedirectionareInstitutie({
  redirectInstitution,
  setRedirectInstitution,
  redirectReason,
  setRedirectReason,
  isStatusSolved,
  formActionsData,
  handleRedirectToInstitution,
  currentInstitution // <-- add this prop
}) {
  const handleConfirmRedirect = async () => {
    // Prevent update if institution is unchanged
    if (redirectInstitution === currentInstitution) {
      toast.error("Nu poți redirecționa către aceeași instituție.");
      return;
    }
    const result = await Swal.fire({
      title: "Ești sigur?",
      text: "Vrei să redirecționezi această sesizare?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Da, redirecționează!",
      cancelButtonText: "Anulează"
    });
    if (result.isConfirmed) {
      handleRedirectToInstitution();
    }
  };

  return (
    <SoftBox 
      p={2.5}
      mt={2}
      border="1px solid #eee"
      borderRadius="lg"
      boxShadow="0 2px 12px 0 rgba(0,0,0,0.05)"
      bgcolor="white"
      position="relative"
    >
      <SoftBox position="absolute" top={0} left={0} width="4px" height="100%" bgcolor="info.main" />
      <SoftTypography variant="subtitle2" fontWeight="medium" mb={2} pl={1}>
        <Icon fontSize="small" sx={{ verticalAlign: "middle", mr: 1 }}>swap_horiz</Icon>
        Redirecționează către altă instituție
      </SoftTypography>
      <TextField
        select
        fullWidth
        value={redirectInstitution}
        onChange={(e) => setRedirectInstitution(e.target.value)}
        disabled={!!isStatusSolved}
        size="small"
        placeholder="Selectează instituția"
        sx={{ mb: 1.5, "& .MuiOutlinedInput-root": { borderRadius: "8px" } }}
        SelectProps={{
          displayEmpty: true,
          renderValue: (selected) => {
            const selectedLabel = formActionsData?.institution_choices?.find(opt => opt.value === selected)?.label || selected || "Selectează instituția";
            return (
              <SoftBox display="flex" alignItems="center">
                <Icon fontSize="small" sx={{ mr: 1 }}>business</Icon>
                {selectedLabel}
              </SoftBox>
            );
          }
        }}
      >
        {formActionsData?.institution_choices?.length
          ? formActionsData.institution_choices.map((inst) => (
              <MenuItem key={inst.value} value={inst.value}>
                <SoftBox display="flex" alignItems="center">
                  <Icon fontSize="small" sx={{ mr: 1 }}>business</Icon>
                  {inst.label}
                </SoftBox>
              </MenuItem>
            ))
          : <MenuItem value="" disabled>Nu există opțiuni</MenuItem>
        }
      </TextField>
      <textarea
        style={{
          width: "100%",
          minHeight: 60,
          height: 80,
          borderRadius: 8,
          border: "1px solid #ccc",
          padding: 8,
          fontFamily: "inherit",
          fontSize: "0.875rem",
          resize: "vertical",
          marginBottom: 12,
          boxSizing: "border-box",
        }}
        placeholder="Motivul redirecționării"
        value={redirectReason}
        onChange={(e) => setRedirectReason(e.target.value)}
        disabled={!!isStatusSolved}
      />
      <SoftButton 
        variant="gradient" 
        color="info" 
        size="small"
        disabled={!!isStatusSolved || !redirectInstitution}
        fullWidth
        sx={accentBtnSx}
        onClick={handleConfirmRedirect}
      >
        <Icon fontSize="small" sx={{ mr: 0.5 }}>send</Icon>
        Trimite către altă instituție
      </SoftButton>
    </SoftBox>
  );
}

ActionRedirectionareInstitutie.propTypes = {
  redirectInstitution: PropTypes.string.isRequired,
  setRedirectInstitution: PropTypes.func.isRequired,
  redirectReason: PropTypes.string.isRequired,
  setRedirectReason: PropTypes.func.isRequired,
  isStatusSolved: PropTypes.bool.isRequired,
  formActionsData: PropTypes.object,
  handleRedirectToInstitution: PropTypes.func.isRequired,
  currentInstitution: PropTypes.string.isRequired // <-- add prop type
};
